import Vue from 'vue'
import Vuex from 'vuex'
import persist from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 顶部高度
    headerHeight: '',
  },
  getters:{

  },
  mutations: {
    // 储存顶部高度
    saveHeaderHeight(state, e) {
      state.headerHeight = e
    },
  },
  actions: {

  },
  plugins: [
    new persist({
      storage: window.localStorage,
    }),
  ],
})



// WEBPACK FOOTER //
// ./src/store/index.js